module.exports = ELEMENT;


//////////////////
// WEBPACK FOOTER
// external "ELEMENT"
// module id = l6IN
// module chunks = 30